import './classe.scss';
import React, { useEffect, useRef, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Card, Breadcrumb, Descriptions, Tabs, Grid, message, Tooltip } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import ClasseOptions from './options-classe';
import { getClasse } from './classe.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { getElevesByClasse } from '../eleve/eleve.reducer';
import { deleteCalendar, deleteCalendarEntry, getCalendar, updateCalendarEntry } from '../calendar/calendarEntry.reducer';
import { getSortState } from 'react-jhipster';
import { getSession } from 'app/shared/reducers/authentication';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';

import moment from 'moment';
import 'moment/locale/fr';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import { getMatieresWithCoeffByClasseId } from '../matiere-ecole/matiere-ecole.reducer';
import { useHasAnyAuthority } from 'app/hooks/useHasAnyAuthority';
import { getEcoleActiveAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
import ClasseCalendar from './ClasseCalendar';
import ClasseEleves from './ClasseEleves';
import ClasseMatieres from './ClasseMatieres';

moment.locale('fr');

const { useBreakpoint } = Grid;

export const ClasseDetail = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const dispatch = useAppDispatch();
  const { TabPane } = Tabs;
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const requiredAuthorities = [AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR, AUTHORITIES.DIRECTEUR_ETUDE];
  const hasPermission = useHasAnyAuthority(requiredAuthorities);
  const isProf = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.PROFESSEUR]));

  const currentEcole = useAppSelector(state => state.ecole.entity);
  const classe = useAppSelector(state => state.classe.entity);
  const matieresWithCoeff = useAppSelector(state => state.matiereEcole.matiereWithCoeff);

  const screens = useBreakpoint();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const [dataSource, setDataSource] = useState<any[]>([]);

  useEffect(() => {
    const data = matieresWithCoeff
      .map(matiereCoeff => ({
        key: matiereCoeff.matiere.id,
        matiere: matiereCoeff.matiere.nom,
        coeff: matiereCoeff.coeff,
      }))
      .reverse();
    setDataSource(data);
  }, [matieresWithCoeff]);

  const ecoleid = props.match.params.ecoleid;
  const classeid = props.match.params.id;

  useEffect(() => {
    dispatch(getSession());
    dispatch(getClasse(classeid));
    dispatch(getEcole(ecoleid));
  }, [paginationState.activePage]);

  return (
    <div className="classe-detail-container">
      <Breadcrumb className="custom-breadcrumb">
        {!isProf && (
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole?.id}`}>{currentEcole?.nom}</Link>
          </Breadcrumb.Item>
        )}
        <Breadcrumb.Item>
          <Link to={`/classe/${currentEcole?.id}`}>Classes</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Détails</Breadcrumb.Item>
      </Breadcrumb>
      <Card className="header-card">
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col xs={24} md={18}>
            <Descriptions column={1}>
              <Descriptions.Item>
                <h2 className="classe-title">{classe.nom}</h2>
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <Col xs={24} md={6} style={{ textAlign: screens.xs ? 'center' : 'right' }}>
            {isNotComptable && isNotSurveillantGeneral && !isProf && <ClasseOptions {...props} />}
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ClasseDetail;
